import { useEffect, useState } from "react";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { formatFilterValues, formatSingleTime } from '@/pages/dashboard/utils/utils';
import { getDefaultUtcDateValue } from "@/pages/dashboard/utils/dateUtils";
import { dailyRequest } from "../../pages/overview/_config/dailyRequest";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useDailyMetricsModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean, regionDataType: string, dailyReqType='normal') => {
  const { gameCode, } = props;
  const formVal = formValue || dailyFilterDefault;
  const [componentData, setComponentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  // 进入页面的时候
  // useEffect(() => {
  //     if (!formValue) return;
  //     // const dvaData = serviceData?.[OVERVIEW_DAILY_METRICS];
  //     // if (dvaData) {
  //     //     setComponentData(dvaData?.data)
  //     // } else {
  //         // 当筛选器加载完成后再进行页面请求
  //         if (!filterLoading) {
  //             geMetricsDataFunc()
  //         }
  //     // }
  // }, [filterLoading])

  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    if (!filterLoading) {
      geMetricsDataFunc();
    }
  }, [formVal, filterLoading]);


  const geMetricsDataFunc = (isRefresh?: boolean) => {
    const { filterValue, diff, timeType } = formVal;
    // timeZone
    const { rangeTime, ...filters } = filterValue;
    const defaultTimeRange = getDefaultUtcDateValue(formVal?.timeType,rangeTime);
    const rangeTimeArr = diff ?  defaultTimeRange: formatSingleTime(rangeTime, timeType);
    const [start, end] = rangeTimeArr;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
      by_type: regionDataType,
    };
    setLoading(!isRefresh);
    const requestFunc = dailyRequest.getMetricsUsers?.[dailyReqType];
    requestFunc(params).then((result: any) => {
      setError('');
      setLoading(false);
      setComponentData(result);
      dispatch({
        type: "overview/getMetricsDataFunc",
        payload: {
          result
        }
      });
    }).catch((err: any) => {
      setError(err);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useDailyMetricsModel;
